<template>
    <div class="paginate" flex="cross:center main:right" v-if="lastPage > 1">
        <div class="prev" :class="{disabled: currentPage == 1}" @click="toPrePage">
            {{$lang.getLang() == 'cn' ? '上一页' : 'Previous'}}
        </div>
        <div class="page" @click="toPage(c)" :class="{current: c == currentPage || c == '...'}" v-for="(c,i) in pages" :key="i">{{c}}</div>
        <div class="next" :class="{disabled: currentPage == lastPage}" @click="toNextPage">
            {{$lang.getLang() == 'cn' ? '下一页' : 'Next'}}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        lastPage: {
            type: Number,
            default: 1
        }
    },
    computed: {
        pages() {
            let list = []
            for(let i = 1; i <= this.lastPage; i++) {
                if(i > 3 && i < this.lastPage - 2) {
                    if(i >= this.currentPage -1 && i <= this.currentPage + 1){
                        list.push(i)
                    }else{
                        if(list[list.length - 1] != '...'){
                            list.push('...')
                        }
                        continue
                    }
                }else{
                    list.push(i)
                }
            }
            return list
        }
    },
    methods: {
        toPrePage() {
            if(this.currentPage == 1) return
            this.$emit('change', this.currentPage - 1)
        },
        toNextPage() {
            if(this.currentPage == this.lastPage) return
            this.$emit('change', this.currentPage + 1)
        },
        toPage(page) {
            if(page == '...' || page == this.currentPage) return
            this.$emit('change', page)
        }
    }
}
</script>

<style lang="scss" scoped>
.paginate{
    .next,
    .page,
    .prev{
        height: 30px;
        border: 1px solid #a8a8a8;
        border-radius: 2px;
        font-size: 14px;
        padding: 0 10px;
        line-height: 30px;
        cursor: pointer;
        margin-left: 10px;
        color: #333;
    }
    .disabled,
    .current{
        background: #f5f5f5;
        border: 1px solid #f5f5f5;
        cursor: default;
        color: #999;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Paginate.vue